import { Component, type ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Catches errors in the invite accept flow so we show a message instead of a blank page.
 */
export default class InviteAcceptErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('InviteAcceptPage error:', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-md mx-auto">
          <h1 className="text-2xl font-bold mb-6">Something went wrong</h1>
          <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
            We couldn’t load the invite page. Please try the link again or contact support.
          </p>
          <Link to="/login" className="text-text-link underline font-semibold">Go to login</Link>
        </div>
      )
    }
    return this.props.children
  }
}
